import React, { FC } from 'react';
import { connect } from 'react-redux';
import { toggleShowServices } from '@store/actions';
import {
  servicesCatalogModalSelector,
  ServicesCatalogModalProps,
} from './structuredSelector';
import CatalogModal from '../CatalogModal';

interface FullCatalogModalProps extends ServicesCatalogModalProps {
  replaceRoute: (replace: string) => void;
  initialCatalogOpened: boolean;
  toggleShowServices: (payload?: any) => any;
}

const FullCatalogModal: FC<FullCatalogModalProps> = ({
  visible,
  initialCatalogOpened,
  replaceRoute,
  toggleShowServices,
}) => {
  const onClose = () => {
    toggleShowServices(false);

    if (initialCatalogOpened) {
      replaceRoute(window.location.pathname);
    }
  };

  return <CatalogModal visible={visible} onClose={onClose} />;
};

const mapDispatchToProps = (dispatch) => ({
  toggleShowServices: (payload) => dispatch(toggleShowServices(payload)),
});

export default connect(
  servicesCatalogModalSelector,
  mapDispatchToProps
)(FullCatalogModal);
